<template>
  <div>
        <!-- Modal Fotos -->
    <modal id="fotos" name="fotos">
      <div class="box-header title-boreder">
           <div class="box-title box-title-sub">
            <img src="/static/img/icons/ic_photos.png" style="padding-bottom: 6px; padding-right: 8px;"> <span>ver fotos</span>
           </div>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-on:click="$modal.hide('fotos')" style="padding:5px;" >
              <span aria-hidden="true">&times;</span>
            </button>
      </div>
          <div class="modal-body text-center">
            <carousel v-if="window.width > 768" 
              :perPageCustom="[[768, 1], [1024, 1]]"
              :paginationSize="12"
              :paginationActiveColor="'#D3D8DC'">
               <slide v-for="(foto, fotosIndex) in fotos" :key="fotosIndex">
                <img class="textUbication foto-style" :src="'data:image/png;base64,' + foto">
              </slide>
            </carousel>
            <carousel v-if="window.width < 768" 
            :perPageCustom="[[320, 1], [320, ]]"
            :paginationSize="12"
            :paginationActiveColor="'#D3D8DC'">
               <slide v-for="(foto, fotosIndex) in fotos" :key="fotosIndex">
                <img class="textUbication foto-style" :src="'data:image/png;base64,' + foto">
              </slide>
            </carousel>
      </div>
    </modal>
        <!-- Fin Modal -->

    <div class="box-header" v-if="window.width > 510">
      <h3 class="box-title title" style="color:#959FA9">Seguimiento de documento</h3>
      <h3 class="box-title title" style=""><span v-if="window.width > 501" class="table-btn-icon"></span> {{document.documentTypeName}}</h3>
    </div>
    <div v-if="window.width < 510">
      <div class="row">
        <div class="col-sm-6"> <h3 class="box-title title" style="color:#959FA9; margin-top:0px">Seguimiento de documento</h3></div>
        <div class="col-sm-6" style=""> <h3 class="box-title title" style="margin-top:0px">{{document.documentTypeName}}</h3></div>
      </div>
    </div>
  <div class="" style="">
  <router-link :to="{name: 'DocumentSearch', params: {selectedAccount: this.selectedAccount, tracking: true, showAdvance: this.$route.params.showAdvanceMain} }" > 
    <button :class="'btn btn-sm btn-success btnAction btn-search'" style="margin-bottom:30px; width:130px !important"><img class="icon-space" src="/static/img/icons/ic_back.png" style="padding-bottom:7px">Regresar</button>
  </router-link>
  </div>
  <div class="row">
    <div class="col-md-5">
      <div class="box box-success">
        <div class="box-header title-boreder" style="padding-top:12px !important; height:50px !important;">
          <h3 class="box-title box-title-sub"><img src="/static/img/icons/ic_doc2.png" style="padding-bottom:6px;"> <strong style="text-tranform:uppercase">{{document.documentTypeName +' :'}}</strong> <strong>{{document.documentNumber}}</strong></h3>
        </div>
        <div class="title-boreder" style="padding-top:12px !important; height:70px !important;">
          <div class="row">
            <div class="col-sm-5">
              <span class="box-title box-title-sub client-pro-side cliente-prov-size-respo" style="">Cliente/Proveedor: </span>
            </div>
            <div class="col-sm-7">
              <span class="client-box-title-side" style="color: #009D00">{{document.supplierCustomerDescription}}</span>
            </div>
          </div>
        </div>
        <div class="title-boreder" style="padding-top:12px; padding-bottom:12px;">
          <div class="row">
              <div class="col-md-4" style=" font-size: 18px; text-align: center; color:#364A5D">
              <span style=" font-size: 18px; color:#364A5D">{{totalPackages}}<span style=" font-size: 16px"> {{minimumStockUnit}}</span></span>
              <span style="display:block; font-size: 10px;">Total<span style="font-size: 10px; font-weight: bold"> Cantidad </span> </span>
              </div>
              <div class="col-md-4" style=" font-size: 18px; text-align: center; color:#364A5D">
                <span style=" font-size: 18px; color:#364A5D">{{totalWeight | formatWeightKg}}</span>
                <span style="display:block; font-size: 10px;"> Total <span style="font-size: 10px; font-weight: bold">Peso </span> </span>
              </div>
            <div class="col-md-4" style=" font-size: 18px; text-align: center; color:#364A5D">
                <span style=" font-size: 18px; color:#364A5D">{{totalVolume | formatVolM}}</span>
                <span style="display:block; font-size: 10px; font-weight: bold"> Volumen </span>
              </div>
            </div>
        </div>
        <div class="title-boreder" style="font-size: 18px; text-align: center; color:#364A5D; padding-top:12px; padding-bottom:12px;">
          <div class="row">
            <div class="col-md-4">
              <span><img src="/static/img/icons/ic_calendar.png" style="padding-bottom:5px"> {{document.documentDate | formatDate('DD/MM/YYYY')}}</span>
              <span style="display:block; font-size: 10px;">Fecha <span style="font-size: 10px; font-weight: bold">Emisión</span> </span>
            </div>
            <div class="col-md-8">
              <div class="row">
                <div class="col-md-6">
                  <span v-if="orderDeliveryDateConvert >= '2000'"><img src="/static/img/icons/ic_car.png" style="padding-bottom:4px"> {{document.orderDeliveryDate | formatDate('DD/MM/YYYY')}}</span>
                  <span v-else><img src="/static/img/icons/ic_car.png" style="padding-bottom:4px"> __/__/____</span>
                  <span style="display:block; font-size: 10px;">Fecha de <span style="font-size: 10px; font-weight: bold">Entrega</span></span>
                </div>
                <div class="col-md-6">
                  <span v-if="orderDeliveryDateConvert >= '2000'" ><img src="/static/img/icons/ic_time.png" style="padding-bottom:3px"> {{document.orderDeliveryDate | formatDate('HH:mm')}}</span>
                  <span v-else><img src="/static/img/icons/ic_time.png" style="padding-bottom:3px">__:__</span>                  
                  <span style="display:block; font-size: 10px;">Hora de <span style="font-size: 10px; font-weight: bold">Entrega</span>  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="title-boreder" style="padding-top:12px; padding-bottom:12px;" v-if="(this.indicatorViewOrder)">
          <div class="row">
              <div class="col-md-4" style=" font-size: 18px; text-align: center; color:#364A5D">
              <span style=" font-size: 18px; color:#364A5D">{{orderType}}</span>
              <span style="display:block; font-size: 10px;">Tipo<span style="font-size: 10px; font-weight: bold"> Pedido</span> </span>
              </div>
              <div class="col-md-8" style=" font-size: 18px; text-align: center; color:#364A5D">
                <span style=" font-size: 18px; color:#364A5D">{{trackingNumber}}</span>
                <span style="display:block; font-size: 10px;"> Número <span style="font-size: 10px; font-weight: bold"> Tracking</span> </span>
              </div>
            </div>
        </div>
        <div class="title-boreder" style="padding-top:12px; padding-bottom:12px;" v-if="(this.indicatorViewAddress)">
          <div class="row">
              <div class="col-md-4" style=" font-size: 18px; text-align: center; color:#364A5D">
              <span style=" font-size: 18px; color:#364A5D">{{referenceDocumentNumber1}}</span>
              <span style="display:block; font-size: 10px; ">Número<span style="font-size: 10px; font-weight: bold"> Referencia</span> </span>
              </div>
              <div class="col-md-8" style=" font-size: 18px; text-align: center; color:#364A5D">
                <span style=" font-size: 18px; color: #364A5D">{{address1}}</span>
                <span style="display:block; font-size: 10px;"> Dirección <span style="font-size: 10px; font-weight: bold"> Despacho</span> </span>
              </div>
            </div>
        </div>

      </div>
    </div>
    <div class="col-md-7">
      <div class="box box-success" style="height:385px !important;">
        <div class="box-header title-boreder">
          <h3 class="box-title box-title-sub"><img src='/static/img/icons/ic_estado.png' style="padding-bottom:5px; padding-right:8px"> <strong>ESTADO</strong></h3>
        </div>
        <div class="box-header" style="height:65px !important;">
          <h3 class="box-title box-title-sub">AVANCE ESTADO</h3>
        </div>
        <div style="border-bottom: solid; border-color: #F6F6F6 ;height:100px !important; ">
          <div class="status-bar-">
            <strong class="status-bar-title-percentage">{{document.progress}}%</strong>
            <strong class="status-bar-title">{{document.status}}</strong>
          </div>
          <div class="progress status-bar" v-if="document.progress">
            <div :class="'progress-bar progress-bar-' + formatProgress(document.progress)" role="progressbar" :aria-valuenow="document.progress"
              aria-valuemin="0" aria-valuemax="100" :style="'width:' + document.progress + '%'">
            </div>
          </div>
        </div>
            <div class="arkano-stepper" style="padding-top:18px;">
              <div class="arkano-stepper-item" v-for="(state, stateIndex) in document.states" v-bind:key="stateIndex">
                <div class="arkano-stepper-label estateLine" style="color:#364A5D" ><strong>{{state.name}}</strong></div>
                <div :class=" stateCondition(state)">
                  <div class="arkano-stepper-check-border-true" style="background:#364A5D;"  v-if="state.done">
                    <img class="" src="/static/img/icons/ic_check_blue.png">
                  </div>
                  <div class="arkano-stepper-check-border-next" v-if="stateApply.name === state.name">
                    <img class="" src="/static/img/icons/oval_2x.png" >
                  </div>
                  <div class="arkano-stepper-check-border-next" v-if="!state.done && stateApply.name !== state.name">
                    <img class="" src="/static/img/icons/oval_2x.png" >
                  </div>
                </div>
                <div class="arkano-stepper-label-bottom" v-if="state.done" >
                  <strong style="color:#364A5D">{{state.date | formatDate('DD/MM/YYYY')}}</strong><br />
                  <span style="color:#364A5D">{{state.date | formatDate('HH:mm')}}</span>
                </div>
                <!-- <div class="arkano-stepper-label-bottom" v-if="!state.done && stateApply.name === state.name">
                  <strong style="color:#364A5D">__/__/____</strong><br />
                  <span style="color:#364A5D">__:__</span>
                </div> -->
                <div class="arkano-stepper-label-bottom" v-if="!state.done">
                  <strong style="color:#364A5D; opacity:0.3">__/__/____</strong><br />
                  <span style="color:#364A5D; opacity:0.3">__:__</span>
                </div>
              </div>
            </div>
      </div>
    </div>
  </div>
  
  <div class="box-success">
    <div class="title-boreder">
        <h3 class="box-title-sub" style="padding-top:0px !important;"><img src="/static/img/icons/ic_time.png" style="padding-bottom:4px; padding-right:5px;"> <strong>EVENTOS</strong></h3>
    </div>
      <div class="box-body">
        <carousel :perPageCustom="[[768, 1], [1024, 6]]" 
          :class="'stepper-principal-box title-boreder'"
          :paginationSize="12"
          :paginationActiveColor="'#D3D8DC'">
          <slide class="stepper-events-item" v-for="(event, eventIndex) in document.events" :key="eventIndex">
            <div class="stepper-check-events">
              <div class="stepper-top-circle">
                <div :class="((selectedEvent === eventIndex) ? 'stepper-item-circle-btn-select selected' : 'stepper-item-circle-btn-noselect')" v-on:click="showDetail(eventIndex, false)">
                  <img :src="(selectedEvent === eventIndex) ? '/static/img/icons/ic_calendar_white.png' : '/static/img/icons/ic_calendar_black.png'" style="vertical-align: middle;">
                </div>
              </div>
            </div>
            <div class="vl"></div>
            <div :class="'stepper-item-box ' + ((selectedEvent === eventIndex) ? ' stepper-box-back-select' : ' stepper-box-back-noselect')" v-on:click="showDetail(eventIndex, false)">
              <div style="padding-top:8px;">
                <span style="font-size:24px">{{event.date | formatDate('DD/MM/YYYY')}}</span><br>
                <span style="font-size:15px">{{event.date | formatDate('HH:mm')}}</span><br>
                <span style="font-size:12px; font-weight:900">{{event.name}}</span><br />
              </div>
            </div>
              <div :class="'stepper-item-box-arrow ' + ((selectedEvent === eventIndex) ? 'stepper-item-box-arrow-bg': '')"> </div>
            </slide>
            </carousel>

            <div class="" style="text-align: center;">            
              <h3 class="box-title-sub" style="texrt-transform:uppercase; color:#009D00; font-weight:bold; font-family:'Avenir', 'Arial';"><strong>EVENTO: {{document.events[selectedEvent].name}}</strong></h3>
              <!-- <h3 class="box-title box-title-sub" style="color:#009D00; font-weight:bold; font-family:Avenir;"><strong>EVENTO: {{event.name.toUpperCase()}}</strong></h3> -->
            </div>
            <div class="row">
            <div class="" style="text-align: center;padding-top:20px !important;">            
              <div class="col-md-3">
                   <img src="/static/img/icons/ic_calendar.png" style="padding-bottom: 10px; padding-right: 8px; "> <span style="font-size:26px">{{document.events[selectedEvent].date | formatDate('DD/MM/YYYY')}}</span><br>
                      <div class="eventBorder" >
                      <span  style="font-size:15px">Fecha</span>
                      </div>
              </div>
              <div class="col-md-3">
               <img src="/static/img/icons/ic_time.png" style="padding-bottom: 10px; padding-right: 8px;"> <span style="font-size:26px">{{document.events[selectedEvent].date | formatDate('HH:mm')}}</span><br>
                  <div class="eventBorder">
                    <span style="font-size:15px;">Hora</span>
                  </div>
              </div>

              <!-- Ubicacion -->
              
              <div class="col-md-3" >
                <div v-if="ubicationState">
                 <img src="/static/img/icons/ic_location.png" style="padding-bottom: 10px; padding-right: 8px;"><a class="modal-fotos" style="font-size:26px" v-on:click="onUbicationModal()">{{ubicacionStatus}}</a>
                </div>

                <div v-if="!ubicationState">
                  <img src="/static/img/icons/ic_location.png" style="padding-bottom: 10px; padding-right: 8px;"><a class="modal-fotos" style="font-size:26px; color:black !important">Ubicación no disponible</a>
                </div>

              </div>

              <!-- Fotos -->

              <div class="col-md-3">
                <div>
                  <img v-if="!fotoEnable" src="/static/img/icons/ic_photos.png" style="padding-bottom: 10px; padding-right: 8px;"> <span v-if="!fotoEnable"  class="modal-fotos" style="font-size:26px" >Fotos no disponible</span>

                  <img v-if="fotoEnable" src="/static/img/icons/ic_photos.png" style="padding-bottom: 10px; padding-right: 8px;"> <a v-if="fotoEnable"  class="modal-fotos" style="font-size:26px" v-on:click="modalFotos()" >ver fotos</a>
                </div>
              </div>
          </div>
        </div>
    
        <div class="" style="padding-top:20px !important;">            
          <h3 class="box-title box-title-sub" style="text-transform:uppercase; color:#4F6071; font-size:15px; font-weight:bold;"><strong>{{document.events[0].name + ': PRODUCTOS'}}</strong></h3>
          </div>
        <div class="row">
          <div id="detail" class="col-md-12">
          <vuetable 
            id="detail"
            ref="vuetable"
            :api-mode="false"
            :fields="tableFields"
            :css="tableCSS.table"
            noDataTemplate="No se encontraron resultados"
            :data="tableData"
            :data-manager="dataManager"
            pagination-path="pagination"
            @vuetable:pagination-data="onPaginationData"
            :key="tableKey"
          >
          
            <div id="Descripción" slot="description" slot-scope="props">
                <span >{{props.rowData.description}}</span>
            </div>

              <div id="Proveedor" slot="provider" slot-scope="props">
                <span >{{props.rowData.provider}}</span>
            </div>

              <div id="Cantidad" slot="totalPackages" slot-scope="props">
                <span >{{props.rowData.amount}}<span style=" font-size: 12px"> {{minimumStockUnit}}</span></span>
            </div>

              <div id="Peso" slot="weight" slot-scope="props">
                <span >{{formatWeightKg(props.rowData.weight)}}</span>
            </div>

              <div id="Volumen" slot="volume" slot-scope="props">
                <span >{{formatVolM1(props.rowData.volume)}}</span>
            </div>


          </vuetable>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            &nbsp;
            <template v-if="this.paginationData && paginationData.total > 0">
              <strong style="color: #364A5D; paddin-left:15px;">
              Mostrando documento {{ this.paginationData.from }} a {{ this.paginationData.to }} de {{ this.paginationData.total }} en Total
              </strong>
            </template>
          </div>
          <div class="col-md-6">
            <vuetable-pagination ref="pagination"
              :css="tableCSS.pagination"
              @vuetable-pagination:change-page="onChangePage"
            ></vuetable-pagination>
          </div>
        </div>
        </div> 
    </div>
<!-- Modal Ubicacion -->
   <modal id="ubication" name="ubication" >
      <div class="box-header title-boreder">
           <div class="box-title box-title-sub">
            <img src="/static/img/icons/ic_location.png" style="padding-bottom: 6px; padding-right: 8px;"> <span>ver ubicación</span>
           </div>
            <button  type="button" class="close" data-dismiss="modal" aria-label="Close" v-on:click="$modal.hide('ubication')" style="padding:5px;">
              <span aria-hidden="true">&times;</span>
            </button>
      </div>

     <div v-if="ubicationState">
        <gmap-map
          :center="center"
          :zoom="zoom"
          style="width:100%;  height: 475px;"
          >
            <gmap-marker
              :position="this.center"
              icon="/static/img/icons/ic_truck_50.png"
              >
            </gmap-marker>
          </gmap-map>
     </div>
   </modal>
  
  </div>
</template>
<style>

#ubication .v--modal{
   width: 1000px !important;
   height: 534px !important;
   position: absolute;
   left: 50%;
   top: 50%; 
   margin-left: -180px;
   margin-top: -120px;
}


  .modal-fotos:hover{
    cursor:pointer;
  }

  .stepper-item-box:hover{
    cursor:pointer; 
  }
  .state-event {
    border: gray 1px solid;
    border-radius: 5px;
    margin: 3px 5px;
    padding: 10px 5px;
  }

  .mode-group {
    margin-top: 20px;
  }

  .field-ro {
    border: gray 1px solid;
    border-radius: 5px;
    padding: 10px 5px;
    margin: 3px auto;
  }

  .state-label {
    border: gray 1px solid;
    border-radius: 5px;
    text-align: center;
    padding: 10px 5px;
    margin: 3px auto;
    cursor: pointer;
    background-color:#00224c;
    font-weight: bold;
    color: white;
  }

  .state-label.bg-success {
    background-color: #3c7f2a;
  }

  .state-label:hover{
    background-color:#009d00;
    font-weight: bold;
    color: white;
    border: 2px solid black
  }

  .flex-container { 
    display: -webkit-flex; 
    display: flex; 
    -webkit-flex-flow: row wrap; 
    flex-flow: row wrap; 
  }

  .flex-item { 
    -webkit-flex: 1 auto; 
    flex: 1 auto; 
  }

  table.itemsList {
    border-radius: 0.5em;
    border-collapse: collapse;
    overflow: hidden;
  }

  table.itemsList TH {
    padding: 5px 5px;
    color: gray;
    border: white 1px solid;
    background-color: rgb(233, 233, 233);
  }

  table.itemsList TD {
    border: white 1px solid;
    background-color: rgb(233, 233, 233);
  }

  .detailTable th {
    background-color: #009d00;
    color:white;
    text-align: center;
  }
  
  .documentRuler {
    border-width: 2px;
  }

  /* Detail*/

  .vuetable th#_totalPackages,
  .vuetable th#_weight,
  .vuetable th#_volume { 
    width: 12%; 
  }

  #detail-summary {
    width: 36%;
    border-collapse: collapse;
  }

  #detail th, #detail td, #detail-summary th, #detail-summary td {
    padding-left: 5px;
    padding-right: 5px;
  }

  #detail-summary th {
    background:#009d00;
    color: white;
    width: 150px;
    text-align: center;
  }

  #detail-summary td {
    font-weight: bold;
    text-align: center;
  }

  #detail-summary th#_totalPackages,
  #detail-summary th#_weight,
  #detail-summary th#_volume { 
    width: 33.33%; 
  }

  .progressInfo {
    z-index: 10;
    padding-top: 5px;
    line-height: 15px;
  }
  .progress, .progress > .progress-bar{
    height: 25px;
  }
  .v-stepper {
    display: flex;
  }
  .v-stepper, .v-stepper__header{
    box-shadow: none !important;
  }
  .v-stepper__step--complete .v-stepper__step__step {
    border: #009d00 2px solid !important;
    background-color: #fff;
  }
  .v-stepper__step--complete .v-stepper__step__step i {
    color: #009d00 !important;
  }
  .v-divider {
    border-color: #009d00;
  }
  .step-label {
    position: relative;
    text-align: center;
  }
  .step-label .step-label-top {
    top: -60px;
    display: block;
    position: absolute;
    width: 100%;
  }

  .arkano-stepper {
    display: flex;
    align-items:flex-start;
  }
  .arkano-stepper-vertical {
    flex-direction: column
  }
  .arkano-stepper-item {
    display: flex;
    flex-direction: column;
    flex-grow:1;
  }

  .stepper-events-item {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
  .arkano-stepper-vertical .arkano-stepper-item {
    flex-direction: row;
    width: 100%;
    justify-content: center;
  }
  .arkano-stepper-label {
    flex-grow: 1;
    text-align: center;
  }
  .arkano-stepper-label-bottom {
    padding-top: 0.5em;
    text-align: center;
  }
  .arkano-stepper-label-left {
    text-align: right;
    flex-basis: 0%;
    flex-grow: 1;
    align-self: center;
  }
  .arkano-stepper-label-right {
    flex-grow: 2;
    flex-basis: 0%;
    align-self: center;
  }

  .arkano-stepper-check {
    margin-top: 0.5em;
    flex-grow: 2;
    background-image: url("/static/img/stepper-tile-h_blue.gif");
    background-color: red;
    background-position-x: center;
    background-position-y: center;
  }
  
  .arkano-stepper-check-status-true {
    margin-top: 0.5em;
    flex-grow: 2;
    background-image: url("/static/img/stepper-tile-h_blue.gif");
    background-position-x: center;
    background-position-y: center;
  }
   
  .arkano-stepper-check-status-next {
    margin-top: 0.5em;
    flex-grow: 2;
    background-image: url("/static/img/line_gray.gif");
    background-position-x: center;
    background-position-y: center;
  }
  
  .arkano-stepper-check-status-false {
    margin-top: 0.5em;
    flex-grow: 2;
    background-image: url("/static/img/stepper-green-tile-h.gif");
    background-position-x: center;
    background-position-y: center;
  }

   .stepper-check-events {
    margin-top: 0.5em;
    flex-grow: 2;
    background-image: url("/static/img/line_gray.gif");
    background-position-x: center;
    background-position-y: center;
  }

  .arkano-stepper-item:first-child .arkano-stepper-check{
    background-position-y: -51.5px;
  }
  .arkano-stepper-item:last-child .arkano-stepper-check{
    background-position-y: -337.5px;
  }

  .arkano-stepper-item:first-child .arkano-stepper-check-status-true{
    background-position-y: -51.5px;
  }
  .arkano-stepper-item:last-child .arkano-stepper-check-status-true{
    background-position-y: -337.5px;
  }

    .arkano-stepper-item:first-child .arkano-stepper-check-status-false{
    background-position-y: -51.5px;
  }
  .arkano-stepper-item:last-child .arkano-stepper-check-status-false{
    background-position-y: -337.5px;
  }
  
  .arkano-stepper-item:first-child .arkano-stepper-check-status-next{
    background-position-y: -51.5px;
  }
  .arkano-stepper-item:last-child .arkano-stepper-check-status-next{
    background-position-y: -337.5px;
  }

  .stepper-events-item:first-child .vl{
    margin-left: 11px;
  }

  .stepper-events-item:first-child .stepper-check-events{
     /* background-position-y: -41.5px;*/ 
     margin-left: 12px;
  }
  .stepper-events-item:last-child .stepper-check-events{
    /* background-position-y: -327.5px;9 */
    background: none;
  }
  .arkano-stepper-¡ .arkano-stepper-check {
    flex-grow: 0;
    width: 50px;
    background-image: url("/static/img/stepper-tile-v.gif");
    margin-top: 0px;
    padding-top: 2em;
    padding-bottom: 2em;
  }
  .arkano-stepper-vertical .arkano-stepper-item:first-child .arkano-stepper-check{
    background-position-x: -761px;
    background-position-y: center;
  }
  .arkano-stepper-vertical .arkano-stepper-item:last-child .arkano-stepper-check{
    background-position-x: -46px;
    background-position-y: center;
  }

  .arkano-stepper-check-border-true {
    display: block;
    margin: 0px auto;
    height: 40px;
    width: 40px;
    overflow: hidden;
    border: #364A5D 2.5px solid !important;
    border-radius: 50%;
    color: #364A5D;
    text-align: center;
    line-height: 35px;
    background-color:#364A5D;
  }
  .arkano-stepper-check-border-false {
    display: block;
    margin: 0px auto;
    height: 40px;
    width: 40px;
    overflow: hidden;
    border: #009D00 2.5px solid !important;
    border-radius: 50%;
    color: #009D00;
    text-align: center;
    line-height: 35px;
    background-color:#009D00;
  }

    .arkano-stepper-check-border-next {
    display: block;
    margin: 0px auto;
    height: 40px;
    width: 40px;
    overflow: hidden;
    text-align: center;
    line-height: 35px;
  }

  .stepper-principal-box{
    display:flex;
    align-items:flex-start;
  }

  .stepper-item-box {
    display: block;
    height: 95px;
    width: 200px;
    overflow: hidden;
    text-align: center;
    text-align: center;
  }

  .stepper-item-box-arrow {
    display: block;
    height: 20px;
    width: 20px;
    overflow: hidden;
    text-align: center;
    text-align: center;
    margin-bottom: 22px; 
    margin-left: 90px;
  }

  .stepper-item-box-arrow-bg{
    background-image: url("/static/img/icons/triangle.png");
    background-repeat: no-repeat;
    background-size: contain;
  }

  .stepper-box-back-select{
    background-color:#364A5D;
    color:#F2F4F6;
  }

  .stepper-box-back-noselect{
    background-color:#F2F4F6;
    color:#364A5D;
  }

  .stepper-item-circle-btn-select {
    height: 60px;
    width: 60px;
    overflow: hidden;
    border: #364A5D 2.5px solid !important;
    border-radius: 50%;
    color: #364A5D;
    text-align: center;
    line-height: 50px;
    background-color:#364A5D;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
  }

    .stepper-item-circle-btn-noselect {
    height: 60px;
    width: 60px;
    overflow: hidden;
    border: #CCEBCC 2.5px solid !important;
    border-radius: 50%;
    color: #CCEBCC;
    text-align: center;
    line-height: 50px;
    background-color:#CCEBCC;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
  }

  .stepper-item-circle-btn-select:active {
    -webkit-box-shadow: inset 0 3px 5px rgba(0,0,0,0.125);
    -moz-box-shadow: inset 0 3px 5px rgba(0,0,0,0.125);
    box-shadow: inset 0 3px 5px rgba(0,0,0,0.125);
  }

 .stepper-item-circle-btn-noselect:active {
    -webkit-box-shadow: inset 0 3px 5px rgba(0,0,0,0.125);
    -moz-box-shadow: inset 0 3px 5px rgba(0,0,0,0.125);
    box-shadow: inset 0 3px 5px rgba(0,0,0,0.125);
  }
  
  .arkano-stepper-purple .arkano-stepper-check-border{
    border: #483d8b 2.5px solid !important;
    color: #483d8b;
  }

  .arkano-stepper-purple .arkano-stepper-label-right {
    color: #483d8b;
  }

  .arkano-stepper-purple.arkano-stepper-vertical .arkano-stepper-check {
    flex-grow: 0;
    width: 50px;
    background-image: url("/static/img/stepper-tile-purple-v.gif");
    margin-top: 0px;
    padding-top: 2em;
    padding-bottom: 2em;
  }

  .glyphicon-filled-circle {
    background-color: #483d8b;
    border: #483d8b 1px solid;
    height: 1.8em;
    width: 1.8em;
    border-radius: 50%;
    margin-top: 0.3em;
  }
  dl.doc-info dd{
    padding-bottom: 1em;
  }
  .btn-event-detail {
    border: #009d00 1px solid;
    border-radius: 5px;
    color: #009d00;
    cursor: pointer;
    display: inline-block;
    font-size: x-small;
    padding: 5px 10px;
  }
  .btn-event-detail:hover {
    background-color: #d2f7e1;
  }
  .btn-event-detail.selected {
    background-color: #009d00;
    color: #ffffff;
  }
  
  .status-bar{
    height: 15px !important;
    width: 90%;
    margin-left: 5%;
  }

  .status-bar-title-percentage{
    font-size: 24px;
    color: #009D00;
  }

  .status-bar-title{
    font-size: 14px;
    color: #444444;
  }

  .status-bar-{
    padding-left: 60%;
    padding-bottom: 1%;
  }

.guide-selected{
  text-align: center;
  }

.vl {
  text-align: center;
   background-image: url("/static/img/line_blue.gif"); 
   width: 60px;
   height: 20px;
   background-size: cover;
}

.cliente-prov-size-respo{
  font-size: 15px; 
  padding-right:15px; 
  font-weight:bold; 
  position:relative; 
  top:10px  
}
.client-box-title-side{
 text-transform: uppercase;
}

.foto-style {
  height:380px;
  width:450px
}

@media screen and (max-width: 1400px) {
.client-box-title-side{
    font-size: 20px !important;
  }
.client-pro-side{
   top:0  !important;
  font-size: 15px !important;
  }
}

@media screen and (max-width: 1280px) {
.client-box-title-side{
    font-size: 18px !important;
  }
.client-pro-side{
   top:0  !important;
  font-size: 15px !important;
  }
}

@media screen and (max-width: 1000px){
  #ubication .v--modal{
  height: 600px !important;
  width: 600px !important;
  left: 30% !important;
  top: 30% !important;    
  } 

  #ubication .vue-map-container{
    height: 540px !important;
  }

  #fotos .v--modal{
    height: 600px !important;
    width: 600px !important;
    left: 30% !important;
    top: 30% !important;    
  }   
  .foto-style {
    height:380px;
    width:450px
  }

}

@media screen and (max-width: 990px) {

.eventBorder{
    border-bottom: #F2F4F6 dashed 2px;
  }
}

@media screen and (max-width: 770px) {
.client-box-title-side{
    padding-left: 15px;
  }

  .client-pro-side{
    top:-5  !important;
    font-weight: 900 !important
  }
}

@media screen and (max-width: 600px) {

   .close{
    top: -42px !important;
    position: relative !important;
  }

  
  #ubication .v--modal{
  height: 500px !important;
  width: 300px !important;
  left: 60% !important;
  }

  #ubication .vue-map-container{
    height: 440px !important;
  }

  #fotos .v--modal{
  height: 500px !important;
  width: 300px !important;
  left: 60% !important;
  }

  .textUbication{
    font-size: 20px !important;
  }



  #documentTypeCode td{
    padding-left: 50%  !important
  }

   #detail table {
      border: 0;
    }

   #detail table thead {
      display: none;
    }

   #detail table tr {
      margin-top: 10px;
      margin-bottom: 20px;
      display: block;
      border:  3px solid;
      border-color:#F2F4F6;
      background-color: white !important;
    }

   #detail table td {
      display: block;
      border: none !important;
      font-size: 12px;
      text-align: right;
      padding: 4px 10px 5px 10px;
    }

   #detail table td:last-child {
      border-bottom: 0;
    }

    #detail table td div::before{
      content: attr(id);
      float: left;
      text-transform: uppercase;
      font-weight: bold;
    }
    	#detail	tbody{
			line-height:0!important;
		}

    .table-btn {
    float: none !important;
    background: none !important;
  }

  .foto-style {
    height:350px;
    width:250px
  }

}

@media screen and (max-width: 360px){
  #ubication .v--modal{
  width: 300px !important;

  } 

  #fotos .v--modal{
    width: 300px !important;
  } 
}

</style>

<script>
import { mapActions, mapGetters } from 'vuex'
import constants from 'assets/js/constants.js'
import { Vuetable, VuetablePagination } from 'vuetable-2'
import { Carousel, Slide } from 'vue-carousel'
import moment from 'moment/moment.js'
import { loadGmapApi, gmapApi } from 'vue2-google-maps'

export default {
  name: 'DocumentMonitoring',
  data () {
    return {
      ...mapGetters([
        'dummyDocument'
      ]),
      tableKey: 1,
      tableData: null,
      loader: null,
      selectedEvent: 0,
      stateGroups: [],
      fotos: [],
      fotosEnable: false,
      fotoTest: null,
      documentNumber: -1,
      documentStartDate: null,
      documentEndDate: null,
      currentClientCode: null,
      stateFalse: false,
      fotoEnable: false,
      ubicacionStatus: 'ver ubicación',
      ubicationState: false,
      orderDeliveryDateConvert: null,
      stateApply: {
        name: 'nada'
      },
      window: {
        width: 0,
        height: 0
      },
      document: {
        events: [{}]
      },
      detailVisible: {},
      currentClient: {},
      tableFields: [
        {
          name: '__slot:description',
          title: 'Descripción',
          titleClass: 'text-center'
        },
        {
          name: '__slot:provider',
          title: 'Proveedor / Cliente',
          titleClass: 'text-center'
        },
        {
          name: '__slot:totalPackages',
          title: 'Cantidad',
          titleClass: 'text-center',
          dataClass: 'text-center'
        },
        {
          name: '__slot:weight',
          title: 'Peso',
          callback: 'formatWeightKg',
          titleClass: 'text-center',
          dataClass: 'text-center'
        },
        {
          name: '__slot:volume',
          title: 'Volumen',
          callback: 'formatVolM',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }
      ],
      tableCSS: null,
      tableOptions: {
        filterable: false,
        texts: {
          count: ''
        }
      },
      centerDefault: {
        lat: 0,
        lng: 0
      },
      center: null,
      paginationData: null,
      totalPackages: 0,
      totalWeight: 0,
      totalVolume: 0,
      indicatorViewOrder: false,
      indicatorViewAddress: false
    }
  },

  computed: {
    google: gmapApi,
    ...mapGetters(['userClients']),
    ...mapGetters(['userInfo'])
  },
  beforeMount () {
    loadGmapApi({
      key: constants.apiKeyGoogle.vitz
    })
  },
  created () {
    this.tableCSS = constants.tableCSS
    this.documentNumber = this.$route.params.documentNumber
    this.documentType = this.$route.params.documentType
    this.selectedAccount = this.$route.params.selectedAccount
    this.minimumStockUnit = this.$route.params.minimumStockUnit
    this.address1 = this.$route.params.address1
    this.trackingNumber = this.$route.params.trackingNumber
    this.referenceDocumentNumber1 = this.$route.params.referenceDocumentNumber1
    this.codeOrderType = this.$route.params.codeOrderType
    this.orderType = this.$route.params.orderType
    this.indicatorViewOrder = this.isVisibleViewOrder(this.documentType)
    this.indicatorViewAddress = this.isVisibleViewAddress(this.documentType)
    // Obtener datos desde web service
    this.center = this.centerDefault

    this.loader = this.$loading.show({
      loader: 'dots'
    })

    this.tableData = null

    this.getDocument({documentId: this.documentNumber, documentType: this.documentType}).then((response) => {
      this.currentClient = this.userClients.filter(x => x.code === this.selectedAccount.code)[0]
      this.document = response.document
      this.orderDeliveryDateConvert = moment(this.document.orderDeliveryDate).format('YYYY')
      if (this.orderDeliveryDateConvert === '0001') {
        this.document.orderDeliveryDate === ' '
      }
      this.tableData = {
        data: this.document.events[0].items
      }
      this.tableKey++
      this.showDetail(0, true)
    })
  },
  mounted () {
    /* this.geolocate() */
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  methods: {
    ...mapActions([
      'getDocument',
      'getDocumentImage'
    ]),
    geolocate: function () {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }
      })
    },
    onUbicationModal () {
      this.$modal.show('ubication')
    },
    onUbication () {
      let currentEvent = this.document.events[this.selectedEvent]
      this.markers = [this.selectedEvent]
      this.zoom = 14
      let lati = (currentEvent.latitude !== undefined) ? currentEvent.latitude : 0
      let long = (currentEvent.longitude !== undefined) ? currentEvent.longitude : 0
      if (lati === 0 && long === 0) {
        this.ubicationState = false
        return
      } else {
        this.ubicationState = true
      }
      this.center = {
        lat: lati,
        lng: long
      }
      this.tableKey++
    },
    iconFor (mode) {
      switch (mode) {
        case 'BL':
          return '/static/img/icons/ic_recived_containers'
        case 'OC':
        case 'DV':
        case 'PE':
          return '/static/img/icons/ic_storage_arrived'
        case 'GU':
          return '/static/img/icons/ic_delivery_shipped'
        default:
          console.log('Tipo de documento no reconocido: ' + mode)
          return 'undefined'
      }
    },
    stateCondition (state) {
      if (state.done) {
        return 'arkano-stepper-check-status-true'
      } else {
        if (!this.stateFalse || this.stateApply.name === state.name) {
          this.stateFalse = true
          this.stateApply = state
          return 'arkano-stepper-check-status-next'
        } else {
          if (!this.stateApply) {
            return 'arkano-stepper-check-status-next'
          }
          if (this.stateApply.name !== state.name) {
            return 'arkano-stepper-check-status-next'
          }
        }
      }
    },
    modalFotos () {
      this.$modal.show('fotos')
    },
    labelFor (mode) {
      switch (mode) {
        case 'BL':
          return 'Depósito Temporal'
        case 'OC':
        case 'DV':
        case 'PE':
          return 'Almacén'
        case 'GU':
          return 'Despacho'
        default:
          return ''
      }
    },
    validateUbication () {

    },
    colorFor (mode) {
      switch (mode) {
        case 'BL':
          return constants.colorPalette.TemporaryDepositReceived
        case 'OC':
        case 'DV':
        case 'PE':
          return '#345570'
        case 'GU':
          return constants.colorPalette.TransportDelivered
        default:
          return ''
      }
    },
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },
    toggleVisible (index) {
      let _out = !this.detailVisible[index]
      Vue.set(this.detailVisible, index, _out)
      this.$forceUpdate()
    },
    isVisible (index) {
      if (this.detailVisible[index] === undefined) {
        this.detailVisible[index] = false
      }
      return this.detailVisible[index]
    },
    showDetail (eventIndex, first) {
      if (!first) {
        this.loader = this.$loading.show({
          loader: 'dots'
        })
      }
      let imageParam = {
        AccountCode: this.selectedAccount.code,
        documentId: this.documentNumber,
        documentType: this.documentType,
        eventCode: this.document.events[eventIndex].code,
        headerToken: this.userInfo.encodedToken
      }
      this.fotos = []
      if (this.document.events[eventIndex].code === '' || this.document.events[eventIndex].code === null) {
        this.fotoEnable = false
        setTimeout(() => this.loader.hide(), 500)
      } else {
        this.getDocumentImage(imageParam).then((response) => {
          if (response.image1 != null) {
            this.fotos.push(response.image1)
          }
          if (response.image2 != null) {
            this.fotos.push(response.image2)
          }
          if (response.image3 != null) {
            this.fotos.push(response.image3)
          }
          if (response.image4 != null) {
            this.fotos.push(response.image4)
          }

          if (this.fotos.length >= 1) {
            this.fotoEnable = true
          } else {
            this.fotoEnable = false
          }
          this.loader.hide()
        }).catch((error) => {
          this.loader.hide()
          console.log('error ' + error)
        })
      }
      this.selectedEvent = eventIndex
      this.totalPackages = this.document.totalPackages
      this.totalWeight = this.document.totalWeight
      this.totalVolume = this.document.totalVolume
      this.onUbication()
      this.tableData = {
        // data: this.document.events[0].items
        data: this.document.events[eventIndex].items
      }
      this.tableKey++
    },
    base64ToBinary (base64EncodedFile, Name, ID) {
      var i
      var BASE64_MARKER = ';base64,'
      var base64Index = base64EncodedFile.indexOf(BASE64_MARKER) + BASE64_MARKER.length
      var base64 = base64EncodedFile.substring(base64Index)
      var raw = atob(base64)
      var rawLength = raw.length
      var array = new Uint8Array(rawLength)
      for (i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i)
      }
      // var buffer = array.buffer
    },
    goSearch () {
      window.location = '/Documento/Busqueda'
    },
    formatWeightKg (value) {
      return this.$options.filters.formatWeightKg(value)
    },
    formatVolM (value) {
      return this.$options.filters.formatVolM(value)
    },
    formatVolM1 (value) {
      return this.$options.filters.formatVolM1(value)
    },
    formatProgress (documentProgress) {
      let classVal = ''

      if (documentProgress >= 90) {
        classVal = 'success'
      } else if (documentProgress >= 50) {
        classVal = 'warning'
      } else {
        classVal = 'danger'
      }

      return classVal
    },
    /* Table Pagination */
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.paginationData = paginationData
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    dataManager (sortOrder, pagination) {
      let data = []

      if (this.tableData) {
        data = this.tableData.data
        pagination = this.$refs.vuetable.makePagination(data.length)
        data = data.slice(pagination.from - 1, pagination.to)
      } else {
        pagination = this.$refs.vuetable.makePagination(0)
      }

      return {
        pagination: pagination,
        data: data
      }
    },
    isVisibleViewOrder (value) {
      switch (value) {
        case 'PE':
          return true
        default:
          return false
      }
    },
    isVisibleViewAddress (value) {
      switch (value) {
        case 'PE':
          return true
        default:
          return false
      }
    }
  },
  components: {
    Carousel,
    Slide,
    Vuetable,
    'vuetable-pagination': VuetablePagination
  },
  find () {

  },
  destroyed () {
    if (this.loader !== null) {
      this.loader.hide()
    }
  }
}
</script>



// WEBPACK FOOTER //
// DocumentMonitoring.vue?4eb32586